import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { render } from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import { CssBaseline } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import { UserContextProvider } from "./UserContext";
import App from "./App";
import theme from "./theme";
import getUserConfirmation from "./utilities/getUserConfirmation";

render(
  <Router getUserConfirmation={getUserConfirmation}>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <UserContextProvider>
        <App />
      </UserContextProvider>
    </ThemeProvider>
  </Router>,
  document.getElementById("root")
);
